// Custo unitário (Solicitação de Compra): até 7 casas decimais.
// O total de cada item é sempre calculado a partir do custo unitário e
// arredondado em 2 casas — o mesmo que a coluna gerada
// itens_solicitacao_compra.valor_total faz no banco.

export const CUSTO_UNITARIO_MAX_CASAS = 7;

const formatadorCusto = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
  maximumFractionDigits: CUSTO_UNITARIO_MAX_CASAS,
});

/** Exibe o custo unitário com no mínimo 2 e no máximo 7 casas (sem zeros à direita além de 2). */
export const formatarCustoUnitario = (valor: number | string | null | undefined): string =>
  formatadorCusto.format(Number(valor) || 0);

/** Total do item = quantidade × custo unitário, arredondado em 2 casas. */
export const totalItemCusto = (custoUnitario: number | null | undefined, quantidade: number): number =>
  Math.round(((custoUnitario || 0) * quantidade + Number.EPSILON) * 100) / 100;

/** Soma dos totais (já arredondados por item) de uma lista de custos. */
export const totalCustos = (itens: Array<{ valor: number | null; quantidadeSC: number }>): number =>
  itens.reduce((soma, item) => soma + totalItemCusto(item.valor, item.quantidadeSC), 0);

/**
 * Limita o texto digitado (formato pt-BR, vírgula decimal) a `casas` casas
 * decimais, cortando o excedente.
 */
export const limitarCasasDecimais = (texto: string, casas: number = CUSTO_UNITARIO_MAX_CASAS): string => {
  const posicaoVirgula = texto.indexOf(',');
  if (posicaoVirgula === -1) return texto;
  const inteira = texto.slice(0, posicaoVirgula);
  const decimal = texto.slice(posicaoVirgula + 1).replace(/,/g, '').slice(0, casas);
  return `${inteira},${decimal}`;
};
